import PlusIcon from "assets/icon/PlusIcon"

export default function AddButton({ onClick, title = 'Add' }){
    return(
        <button className="button flex items-center gap-2 hover:shadow-lg hover:opacity-85 text-sm" onClick={ onClick }>
            <PlusIcon className="fill-white w-5" />
            <span>{title}</span>
        </button>
    )
}